
<script lang="ts">
    import { Dropdown } from "carbon-components-svelte";
    export let value: string = 'inherit'
    export let label: string = ''

    let valMap = [{'id': 0, 'val': 'inherit'}, {'id': 1, 'val': 'allow'}, {'id': 2, 'val': 'deny'}]
    let selectedId: number = 0

    let oldValue = "inherit"
    let oldIndex: number = 0

    $: {
        if (oldIndex != selectedId) {
            if (selectedId != -1) {
                value = valMap[selectedId].val
            }
        } 
        if (value != oldValue) {
            let val = (valMap.find(v => v.val == value)?.id)
            if (val == undefined) {
                selectedId = 0
                value = valMap[0].val
            } else {
                selectedId = val
            }
        }
        oldValue = value
        oldIndex = selectedId
    } 
</script>

<Dropdown titleText={label} bind:selectedIndex={selectedId}
        items={[{"id": '0', "text":"Inherit"},{"id": '1', "text":"Allow"},{"id": '2', "text": "Deny"}]}/>
